import { useMemo } from "react";
import { useActiveTask } from "@/sdk";
import { userCache } from "@/shared-utils";

export function usePilots(): { pilots: string[] } {
    const activeTask = useActiveTask();

    // biome-ignore lint/correctness/useExhaustiveDependencies: fix later
    const pilots = useMemo(() => {
        return [...userCache.pilots];
    }, [activeTask]);

    return { pilots };
}
